// extracted by mini-css-extract-plugin
export default {"headerContainer":"Header_headerContainer__WfchS","idDateTimeContainer":"Header_idDateTimeContainer__cBUM9"};